import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import {Portuguese} from "flatpickr/dist/l10n/pt";

flatpickr.localize(Portuguese);
window.flatpickr = flatpickr;
